import React from "react";
import api from "../../services/ApiService";
import { useNavigate } from "react-router-dom";
import { TextInput, PasswordInput, Button, Container, Title, Stack, Paper, Alert } from "@mantine/core";
import { MSIcon } from "components/MSIcon.jsx";
import { useTrans } from "core/index.js";

export default function SignUp() {
	const { t } = useTrans();
	const navigate = useNavigate();

	const [name, setName] = React.useState("");
	const [email, setEmail] = React.useState("");
	const [mobile, setMobile] = React.useState("");
	const [password, setPassword] = React.useState("");
	const [kind, setKind] = React.useState(2);

	const [loading, setLoading] = React.useState(false);
	const [nameError, setNameError] = React.useState(null);
	const [emailError, setEmailError] = React.useState(null);
	const [mobileError, setMobileError] = React.useState(null);
	const [passwordError, setPasswordError] = React.useState(null);
	const [globalError, setGlobalError] = React.useState(null);

	const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
	const phoneRegex = /^[0-9]{8,15}$/;

	const validate = () => {
		let v = true;
		setNameError(null);
		setEmailError(null);
		setMobileError(null);
		setPasswordError(null);
		setGlobalError(null);

		if (!name) {
			setNameError(t("signup.nameRequired"));
			v = false;
		}

		if (!email) {
			setEmailError(t("signup.emailRequired"));
			v = false;
		} else if (!emailRegex.test(email)) {
			setEmailError(t("messages.errors.signin.emailPhone"));
			v = false;
		}

		if (!mobile) {
			setMobileError(t("signup.mobileRequired"));
			v = false;
		} else if (!phoneRegex.test(mobile)) {
			setMobileError(t("signup.invalidMobile"));
			v = false;
		}

		if (!password) {
			setPasswordError(t("signup.passwordRequired"));
			v = false;
		}

		return v;
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!validate()) return;

		setLoading(true);
		try {
			await api.signup({
				name: name.trim(),
				email: email.trim(),
				mobile: mobile.trim(),
				password,
				kind: Number(kind),
			});

			navigate("/");
		} catch (err) {
			const msg = err?.data?.message || err.message || "signup.falidSignup";
			setGlobalError(t(msg));
		} finally {
			setLoading(false);
		}
	};

	return (
		<Container size={420} my={40}>
			<Title align="center" order={2} mb={20}>
				{t("signup.signup")}
			</Title>

			<Paper withBorder shadow="md" p={30} radius="md">
				{globalError && (
					<Alert icon={<MSIcon name="alert-circle" />} title={t("messages.error")} color="red" mb={15}>
						{globalError}
					</Alert>
				)}

				<form onSubmit={handleSubmit}>
					<Stack>
						<TextInput
							label={t("signup.name")}
							value={name}
							onChange={(e) => setName(e.target.value)}
							error={nameError}
						/>

						<TextInput
							label={t("signup.email")}
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							error={emailError}
						/>

						<TextInput
							label={t("signup.mobile")}
							value={mobile}
							onChange={(e) => setMobile(e.target.value)}
							error={mobileError}
						/>

						<PasswordInput
							label={t("signup.password")}
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							error={passwordError}
						/>
						<div>
							<strong className="block mb-2">{t("signup.selectRole")}</strong>
							<div className="flex gap-6">
								<label className="flex items-center gap-2 cursor-pointer">
									<input
										type="radio"
										name="kind"
										value={2}
										checked={kind === 2}
										onChange={() => setKind(2)}
										className="w-4 h-4 text-blue-600"
									/>
									<span>{t("signup.owner")}</span>
								</label>

								<label className="flex items-center gap-2 cursor-pointer">
									<input
										type="radio"
										name="kind"
										value={3}
										checked={kind === 3}
										onChange={() => setKind(3)}
										className="w-4 h-4 text-blue-600"
									/>
									<span>{t("signup.user")}</span>
								</label>
							</div>
						</div>

						<Button type="submit" loading={loading} fullWidth>
							{loading ? t("signup.loading") : t("signup.signup")}
						</Button>
					</Stack>
				</form>
			</Paper>
		</Container>
	);
}
